
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mro/[id]",
      function () {
        return require("private-next-pages/mro/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mro/[id]"])
      });
    }
  